// meta-frentista-ia-a5 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A leitura da IA ainda está sendo preparada. Volte em alguns minutos.": "La lectura de la IA todavía se está preparando. Vuelva en unos minutos.",
    "A leitura da IA não está disponível agora. Os números da tela continuam valendo.": "La lectura de la IA no está disponible ahora. Los números de la pantalla siguen valiendo.",
    "Ainda cedo para mexer na meta": "Aún es pronto para cambiar el objetivo",
    "Ainda não há dados suficientes para a leitura da IA.": "Aún no hay datos suficientes para la lectura de la IA.",
    "Ainda sem semana completa": "Aún sin semana completa",
    "Dá para subir a meta": "Se puede subir el objetivo",
    "Indicativo de queda": "Indicativo de caída",
    "Indicativo neutro": "Indicativo neutro",
    "Indicativo positivo": "Indicativo positivo",
    "Manter a meta": "Mantener el objetivo",
    "Vale reduzir a meta": "Conviene reducir el objetivo",
};

export default catalogo;
